import { createFileRoute } from "@tanstack/react-router";
import FeynmanAIGuideFr from "@/pages/resources/fr/FeynmanAIGuideFr";

export const Route = createFileRoute("/fr/learn/feynman-ai")({
  head: () => ({
    meta: [
        {
            "title": "Méthode Feynman + IA : comment l'appliquer à vos cours | System Atlas"
        },
        {
            "name": "description",
            "content": "Combinez la technique Feynman avec des outils IA pour apprendre plus vite. Guide pratique pour appliquer l'enseignement-apprentissage avec l'IA."
        },
        {
            "property": "og:title",
            "content": "Méthode Feynman + IA : comment l'appliquer à vos cours | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Combinez la technique Feynman avec des outils IA pour apprendre plus vite. Guide pratique pour appliquer l'enseignement-apprentissage avec l'IA."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/fr/learn/feynman-ai"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Méthode Feynman + IA : comment l'appliquer à vos cours | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Combinez la technique Feynman avec des outils IA pour apprendre plus vite. Guide pratique pour appliquer l'enseignement-apprentissage avec l'IA."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/fr/learn/feynman-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/feynman-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/feynman-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/feynman-ai"
        }
    ],
  }),
  component: FeynmanAIGuideFr,
});
